var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"entity-form-provider"},[_vm._t("default",null,null,{
        loading: _vm.loading,
        saving: _vm.saving,
        fields: _vm.fields,
        errorsObject: _vm.errorsObject,
        methods: {
          getEntity: _vm.getEntity,
          saveEntity: _vm.saveEntity,
          restartState: _vm.restartState,
          handleSubmit: handleSubmit,
          prepareToSave: _vm.prepareToSave,
        },
      })],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }